import { Space } from "../../components/Space";
import { VStack } from "../../components/Stack";
import { colorStyles, weights } from "./data";

export const createDOMElements = (data: any) => {
  const elements = Object.keys(data).map((key) => {
    const block = data[key];

    const textElements = block.text.map((textItem: any, index: string) => {
      const { characters, weight, color } = textItem;
      const fontWeight = weights.find((style) => style.class === weight)?.class;
      const style = {
        color: colorStyles.find((style) => style.nameCamel === color)?.inlineStyle
      };

      return (
        <span key={index} style={style} className={fontWeight}>{characters}</span>
      );
    });

    const blockClass = block.blockStyle ? `text ${block.blockStyle} ` : 'text body';

    // Render either a block with text or a <Space.NewSection />
    if (block.text.length > 0) {
      return (
        <div key={key} className={blockClass}>
          {textElements}
        </div>
      );
    } else {
      return <Space.NewSection key={key} />;
    }
  });

  // Wrap all elements in a VStack
  return <VStack>{elements}</VStack>;
};
